import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

type ResultModalProps = {
  open: boolean;
  onClose: () => void;
  learningCount: number;
  knownCount: number;
  isFavoritesMode?: boolean;
  favoriteCount?: number;
  onRestartWithLearning: () => void;
  onRestartAll: () => void;
  onGoToTests: () => void;
  nextSessionCount?: number;
  onContinue?: () => void;
};

export function ResultModal({
  open,
  onClose,
  learningCount,
  knownCount,
  isFavoritesMode = false,
  favoriteCount,
  onRestartWithLearning,
  onRestartAll,
  onGoToTests,
  nextSessionCount = 0,
  onContinue,
}: ResultModalProps) {
  const canRestart = !isFavoritesMode || (favoriteCount != null && favoriteCount > 0);

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent style={{ boxShadow: "none" }}>
        {/* 학습 완료 타이틀 */}
        <DialogHeader className="flex flex-col gap-4">
          <DialogTitle className="text-center text-xl font-black text-slate-700">
            {nextSessionCount > 0 ? "세션 완료!" : isFavoritesMode ? "모두 확인했어요!" : "학습 완료!"}
          </DialogTitle>

          {!isFavoritesMode && (
            <div className="text-sm text-muted-foreground *:[a]:underline *:[a]:underline-offset-3 *:[a]:hover:text-foreground">
              <div className="flex justify-center gap-6">
                <div className="flex flex-col items-center gap-1 rounded-2xl bg-orange-50 px-8 py-4">
                  <span className="text-3xl font-black text-orange-500">{learningCount}</span>
                  <span className="text-xs text-muted-foreground font-medium">학습 중</span>
                </div>

                <div className="flex flex-col items-center gap-1 rounded-2xl bg-emerald-50 px-8 py-4">
                  <span className="text-3xl font-black text-emerald-500">{knownCount}</span>
                  <span className="text-xs text-muted-foreground font-medium">알고 있음</span>
                </div>
              </div>
            </div>
          )}
        </DialogHeader>

        <DialogFooter className="border-t-0 bg-transparent flex flex-col! gap-3">
          {nextSessionCount > 0 && onContinue && (
            <Button className="w-full py-5 text-base font-bold" onClick={onContinue}>
              다음 {nextSessionCount}장 계속하기
            </Button>
          )}

          {/* 학습 카운트 버튼 (즐겨찾기 모드에서는 숨김) */}
          {!isFavoritesMode && learningCount > 0 && (
            <Button
              className="w-full py-5 text-base font-bold text-muted-foreground hover:text-muted-foreground"
              variant="outline"
              onClick={onRestartWithLearning}
            >
              단어 {learningCount}개 복습하기
            </Button>
          )}

          {/* 테스트 버튼 */}
          <Button
            className="w-full py-5 text-base font-bold"
            variant={nextSessionCount > 0 ? "outline" : "default"}
            onClick={onGoToTests}
          >
            테스트하러 가볼까요?
          </Button>

          {/* 다시 시작 버튼 (즐겨찾기 모두 해제 시 숨김) */}
          {canRestart && (
            <Button
              className="w-full py-5 text-base font-bold text-muted-foreground hover:text-muted-foreground"
              variant="ghost"
              onClick={onRestartAll}
            >
              다시 시작하기
            </Button>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
